<template>
    <div id="Promotions">
        <v-container class="grey darken-2 ">
            <v-banner dark class="pb-6" single-line>
                <h2>Promotions</h2>
            </v-banner>
            <v-row>
                <v-col cols="12" sm="3" v-for="index in 2" :key="index">
                    <v-card dark>
                        <v-img src="@/assets/Media/Promotions/PromotionTempBg.jpg" class="white--text align-end"
                            gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)" height="200px">
                            <v-card-title>New Year Promotion</v-card-title>
                        </v-img>

                        <v-card-actions>
                            <h3>Completed</h3>
                            <v-spacer></v-spacer>

                            <v-btn icon to="/stickerboard">
                                <v-badge color="red" content="6">
                                    <v-icon>mdi-sticker-emoji</v-icon>
                                </v-badge>
                            </v-btn>

                            <v-btn icon to="/winnings">
                                <v-badge color="red" content="3">
                                    <v-icon>mdi-trophy</v-icon>
                                </v-badge>
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-col>
                <v-col cols="12" sm="3" v-for="index in 2" :key="index">
                    <v-card dark>
                        <v-img src="@/assets/Media/Promotions/PromotionTempBg.jpg" class="white--text align-end"
                            gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)" height="200px">
                            <v-card-title>New Year Promotion</v-card-title>
                        </v-img>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                                <v-progress-linear v-model="skill" color="blue-grey" height="25">
                                    <template v-slot:default="{ value }">
                                        <strong>{{ Math.ceil(value) }}%</strong>
                                    </template>
                                </v-progress-linear>
                                <!-- <p>4 more stickers to go</p> -->

                            <!-- <v-b icon to="/avaiblegames">
                                <v-badge color="red" content="3">
                                    <v-icon>mdi-gamepad</v-icon>
                                </v-badge>
                            </v-btn> -->
                            <v-btn icon to="/stickerboard">
                                <v-badge color="red" content="2">
                                    <v-icon>mdi-sticker-emoji</v-icon>
                                </v-badge>

                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
    export default {
        data: () => ({
            skill: 20,
            knowledge: 33,
            power: 78,
        }),
    }
</script>